import { createContext, useContext } from 'react';

export type SMLFormPresentation = 'modal' | 'inline';

/**
 * How SMLFormContainer should present itself.
 *
 * Every SmartLink form renders SMLFormContainer, and until now that always
 * emitted ModalHeader/ModalBody/ModalFooter. The Creator rail hosts the same
 * forms in a side panel, so the choice travels by context instead of a prop
 * threaded through all six widget forms.
 */
export const SMLFormPresentationContext = createContext<SMLFormPresentation>('modal');

export function useSMLFormPresentation(): SMLFormPresentation {
  return useContext(SMLFormPresentationContext);
}
